export default __webpack_public_path__ + "static/media/illustration-water-leaf.8d6fb8ae.png";